<div class="panel">
    <div class="header" (click)="toggleCollapsed($event)">
        @if (countLabel > 0) {
            <!--Role required for screen reader-->
            <div class="option-count" role="main" attr.aria-label="{{ countLabel }} {{ header }} gewählt" data-cy="facet-panel-option-count">
                {{ countLabel }}
            </div>
        }
        <span
            ><h3 class="facet-panel-header-title">{{ header }}</h3></span
        >
        @if (deleteIcon && countLabel > 0) {
            <button class="delete-button" (click)="deleteIconClicked($event)" data-cy="facet-panel-delete-button">
                <i [ngClass]="deleteIcon" class="highlight" attr.aria-label="Filter {{ header }} löschen"></i>
            </button>
        }
        @if (headerIcon) {
            <button (click)="headerIconClicked($event)" data-cy="facet-panel-header-button">
                <i
                    [ngClass]="headerIcon"
                    [class.highlight]="headerIconHighLighted"
                    [attr.aria-label]="headerIconAriaLabel"
                ></i>
            </button>
        }

        <button (click)="toggleCollapsed($event)">
            <i
                class="pi pi-angle-left"
                [class.expanded]="!collapsed"
                [attr.aria-label]="collapsed ? 'Filter ' + header + ' aufklappen' : 'Filter ' + header + ' zuklappen'"
            ></i>
        </button>
    </div>

    <div class="content" [@collapsibleContent]="collapsed ? 'collapsed' : 'expanded'" [hidden]="collapsed">
        <ng-content></ng-content>
    </div>
</div>
